import {Component, ViewChild, AfterViewInit, ViewContainerRef, ComponentFactory, ComponentRef, ComponentFactoryResolver, EventEmitter} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {MensajeService} from '@mensaje/Mensaje.Service';
import { RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';
import { Modelogoogle } from '@modelo/proceso/modelogoogle.model';
import { AlertaEnum, DialogoEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { EncuestaDetalleComponent } from './general_detalle.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltroModel } from '@componentes/Filtros/Filtro.model';
import { TipoFiltroEnum } from '@componentes/Filtros/Filtros.enum';
import { FiltrosComponent } from '@componentes/Filtros/Filtros.component';
import { GenerarEncuesta } from '@modelo/proceso/generarencuestas.model';
import { FiltroArrayPipe } from '@pipes/FiltroArray.pipe';
import { DxDataGridComponent, DxTreeViewComponent } from 'devextreme-angular';

@Component(
    {
        selector: 'encuesta',
        templateUrl: './general.component.html',
        styleUrls: ['./general.component.scss']
    })

export class EncuestaComponent implements AfterViewInit {

  @ViewChild(DxTreeViewComponent, {static: false}) treeView!: DxTreeViewComponent;

  public animacion!: string;
  public abierto!: boolean;

  consulta!: boolean
  entidad: Modelogoogle;
  enviarEncuesta: GenerarEncuesta;
  token: string = "";

  tienesesion: boolean = false;
  tieneCarpeta: boolean = false;
  errornivel: boolean = false;

  visualizarColaborador: boolean = false;
  visualizarAlumnos: boolean = false;

  micarpeta: string = "";
  selectedRows: any[] = [];
  SelEvaluador:any[] = [];
  SelNivel:any[] = [];
  SelNivellista:any[] = [];
  SelCiclo:any[] = [];
  cicloEnvio:any[] = [];
  SelEncuestaEstatus:any[] = [];
  listaColaborador:any[] = [];
  seleccionado:any[] = [];

  redireccion:string = "";

  tokenredireccion:string = "";


  datatable: any[] = [];
  uriApi: string
  filtrosDisplay: Array<FiltroModel> = [];
  createChildren: any;
  @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
  @ViewChild("encuestadetalle", {read: ViewContainerRef}) encuestadetalle!: ViewContainerRef;

  @ViewChild('grid') private grid!: DxDataGridComponent;

    constructor(private route: ActivatedRoute, private router: Router,private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
      this.uriApi = "encuestagoogle/encuesta/consultar";
      this.entidad = new Modelogoogle();
      this.enviarEncuesta = new GenerarEncuesta();
      this.GenerarFiltros();
    }

    ngAfterViewInit() {
      //this.getEncuestas();
      this.getCredenciales();
      this.SetEvaluadorFiltro();
      this.SetNivel();
      this.SetCicloFiltro();
      this.SetEstatusFiltro();
      this.route.queryParams.subscribe(params => {
        this.token = params['code'] || null;
        this.validarAcceso();
      });

      //this.verforms();
    }

    GenerarFiltros() {
      let filtrosDisplay: Array<FiltroModel> = [];

      filtrosDisplay.push(
          new FiltroModel({
            TipoFiltro: TipoFiltroEnum.Input,
            Titulo: 'Nombre del documento',
            Propiedad: 'nombre',
            MensajeError:""
          }),
          new FiltroModel({
            TipoFiltro: TipoFiltroEnum.DropDownMulti,
            Valor: [],
            Titulo: 'Encuestados',
            DisplayValor: 'nombre',
            ValorName: 'evaluadorid',
            Propiedad: 'evaluadorid',
            Opciones: this.SelEvaluador
          }),
          new FiltroModel({
            TipoFiltro: TipoFiltroEnum.Fecha,
            Titulo: 'Fecha envio',
            Propiedad: 'fechaenvio'
          }),
          new FiltroModel({
            TipoFiltro: TipoFiltroEnum.DropDown,
            Titulo: 'Ciclo',
            DisplayValor: 'nombre',
            ValorName: 'cicloid',
            Propiedad: 'cicloid',
            Opciones: this.SelCiclo
          }),
          new FiltroModel({
            TipoFiltro: TipoFiltroEnum.DropDown,
            Titulo: 'Estatus',
            DisplayValor: 'nombre',
            ValorName: 'encuestaestatusid',
            Propiedad: 'encuestaestatusid',
            Opciones: this.SelEncuestaEstatus
          })
      );

      this.filtrosDisplay = filtrosDisplay;
  }

    validarAcceso(){
      if(this.token != null){
        this.iniciarGoogle();
      }else{
      this.sesionIniciada();
      }
    }

    SetCicloFiltro() {
      this.appService.Get("catalogo/ciclo").then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
              this.SelCiclo = res.data;

              const index = this.SelCiclo.findIndex(objeto => objeto.actual);
              if (index !== -1) {
                let actual = this.SelCiclo[index];
                let anterior = index > 0 ? this.SelCiclo[index + 1] : null;
                this.cicloEnvio.push(actual);
                this.cicloEnvio.push(anterior);
              }
              let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'cicloid');
              if (filtro) {
                  filtro.Opciones = this.SelCiclo;
              }
          }
      });
    }

    SetEstatusFiltro() {
      this.appService.Get("encuestagoogle/encuesta/estatus").then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
              this.SelEncuestaEstatus = res.data;
              let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'encuestaestatusid');
              if (filtro) {
                  filtro.Opciones = this.SelEncuestaEstatus;
              }
          }
      });
    }

    onEditorPreparing(e: any) {
      if (e.dataField === 'selected' && e.parentType === 'dataRow') {
          e.editorOptions = {
              value: false
          }
      }
  }

    modal(){
      if(this.selectedRows.length > 0){
        if(this.selectedRows[0].encuestaestatusid == 1){
          this.animacion = this.sistemaService.animacionAbirModal;
          this.abierto = true;
        }else{
          this.mensajeService.Alerta(AlertaEnum.Warning, "El formulario seleccionado no puede ser enviado")
        }

      }else{
        this.mensajeService.Alerta(AlertaEnum.Warning, "Seleccione un formulario para realizar la configuracion de envio de correos")
      }
    }


    CerrarModal(){
      this.animacion = this.sistemaService.animacionCerrarModal;
      this.enviarEncuesta = new GenerarEncuesta();
      this.visualizarAlumnos = false;
      this.visualizarColaborador = false;
      setTimeout(() => {
          this.abierto = false;
      }, 310);
    }

    SetEvaluadorFiltro() {
      this.appService.Get("catalogo/evaluador").then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
              this.SelEvaluador = res.data;
              this.SelEvaluador = this.SelEvaluador.filter(x=>x.evaluadorid != 5 && x.evaluadorid != 4);
              let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'evaluadorid');
              if (filtro) {
                  filtro.Opciones = this.SelEvaluador;
              }
          }
      });
    }

    SetNivel() {
      this.appService.Get("catalogo/nivel").then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
              this.SelNivel = res.data;
          }
      });
    }


    Evaluador(e: any) {

      if(e.length > 0){
        let colaborador = e.find((x:number)=>x== 1);
        let padre = e.find((x:number)=>x == 2);
        let estudiantes = e.find((x:number)=>x == 3);
        let validar = e.filter((x:number)=>x != 1);
        if(validar.length > 0 && colaborador){
          this.visualizarAlumnos = false;
          this.visualizarColaborador = false;
          this.mensajeService.Alerta(AlertaEnum.Warning, "No se puede juntar");
          this.enviarEncuesta.fechaenvio = "";
          this.enviarEncuesta.horaenvio = "";
          this.enviarEncuesta.cicloid = 0;
          this.enviarEncuesta.nivelid = [];
        }else if((!validar || validar.length == 0) && colaborador){
          this.visualizarColaborador = true;
          this.visualizarAlumnos = false;
          this.enviarEncuesta.fechaenvio = "";
          this.enviarEncuesta.horaenvio = "";
          this.enviarEncuesta.cicloid = 0;
          this.enviarEncuesta.nivelid = [];
        }
        else if(estudiantes && !padre){
          this.visualizarAlumnos = true;
          this.visualizarColaborador = false;
          this.SelNivellista = this.SelNivel.filter(x=>x.nivelid != 1);
          this.enviarEncuesta.fechaenvio = "";
          this.enviarEncuesta.horaenvio = "";
          this.enviarEncuesta.cicloid = 0;
          this.enviarEncuesta.nivelid = [];
          let cicloactual = this.cicloEnvio.find(x=>x.actual);
          if(cicloactual){
            this.enviarEncuesta.cicloid = cicloactual.cicloid;
          }
        }else if((estudiantes && padre) || (!estudiantes && padre)){
          this.visualizarAlumnos = true;
          this.visualizarColaborador = false;
          this.SelNivellista = this.SelNivel;
          this.enviarEncuesta.fechaenvio = "";
          this.enviarEncuesta.horaenvio = "";
          this.enviarEncuesta.cicloid = 0;
          this.enviarEncuesta.nivelid = [];
          let cicloactual = this.cicloEnvio.find(x=>x.actual);
          if(cicloactual){
            this.enviarEncuesta.cicloid = cicloactual.cicloid;
          }
        }
      }else{
        this.visualizarAlumnos = false;
        this.visualizarColaborador = false;
        this.enviarEncuesta = new GenerarEncuesta();
      }

    }

    getEncuestas(){
      this.appService.Post("encuestagoogle/encuesta/consultar", {}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.datatable = res.data;
        }
      })
    }

    getCredenciales(){
      this.appService.Get("encuestagoogle/encuesta/getcredenciales").then(res =>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.tokenredireccion = res.data.token;
          this.redireccion = res.data.redireccion.valor;
        }
      })
    }

    iniciarGoogle(){
      this.appService.Post("encuestagoogle/encuesta/generartoken", {"token":this.token}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){

          this.router.navigate(['/app/encuesta/generarencuesta']);
        }
      })
    }

    sesionIniciada(){
      this.appService.Get("encuestagoogle/encuesta/validarsesion").then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.tienesesion = res.data.tienesesion;
          this.tieneCarpeta = res.data.tienecarpeta;
          this.micarpeta = res.data.carpetaid;
        }
      })
    }

    generarcredenciales(){

      var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

      var form = document.createElement('form');
      form.setAttribute('method', 'GET');
      form.setAttribute('action', oauth2Endpoint);

      var params:any = {'client_id': this.tokenredireccion,
                    'redirect_uri': this.redireccion,
                    'response_type': 'code',
                    'access_type': 'offline',
                    'scope': 'https://www.googleapis.com/auth/drive.metadata.readonly https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/forms.responses.readonly',
                    'include_granted_scopes': 'true',
                    'state': 'pass-through value',};

      for (var p in params) {
        var input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', p);
        input.setAttribute('value', params[p]);
        form.appendChild(input);
      }

      document.body.appendChild(form);
      form.submit();
    }

    verforms(){
      this.appService.Get("encuestagoogle/encuesta/verforms").then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.datatable = res.data;
        }
      })
    }

    SetDatos(event:any){
      this.datatable = event;
    }

    abrirdrive(){
      if(this.micarpeta != ""){
        window.open("https://drive.google.com/drive/folders/"+this.micarpeta, '_blank');
      }
    }


    validar(): any {
      if(!this.enviarEncuesta.fechaenvio){
        return "se requiere asignar una fecha de envio del formulario"
      }

      if(!this.enviarEncuesta.horaenvio){
        return "se requiere asignar una hora de envio del formulario"
      }

      if(!this.enviarEncuesta.cicloid && this.visualizarAlumnos){
        return "Se requiere un ciclo para enviar el formulario"
      }

      if(!this.enviarEncuesta.evaluadorid){
        return "Se requiere asignar minimo un encuestado"
      }
      return true;
    }


    Guardar(){

      let validar = this.validar();

      if(validar != true){
        this.mensajeService.Alerta(AlertaEnum.Warning, validar);
        return;
      }

      if(this.visualizarColaborador){
        let listacolaboradores = this.grid.instance.getSelectedRowsData();
        if(listacolaboradores.length > 0){
          const colaboradorunicos = Array.from(new Map(listacolaboradores.map(item => [item.colaboradorid, item])).values());
          this.appService.Post("encuestagoogle/encuesta/guardarlistadocolaborador", { 'entidad': this.selectedRows[0], 'envio':this.enviarEncuesta, 'listacolaboradores': colaboradorunicos}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                  this.CerrarModal();
                  this.consultainicial();
            }
          })

        }else{
          this.mensajeService.Alerta(AlertaEnum.Warning, "Tienes que seleccionar minimo un colaborador para enviar el formulario");
        }
      }

      if(this.visualizarAlumnos){
        this.seleccionado = [];
        this.treeView.instance.getNodes().map((node) => {
            this.formato(node);
        });
        if(this.seleccionado.length > 0){
        this.appService.Post("encuestagoogle/encuesta/guardarlistadoalumnospadre", {'entidad': this.selectedRows[0], 'envio': this.enviarEncuesta, 'listaalumnopadre': this.seleccionado}).then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
            this.CerrarModal();
            this.consultainicial();
          }
        })
        }else{
          this.mensajeService.Alerta(AlertaEnum.Warning, "Tienes que seleccionar minimo un alumno para enviar el formulario");
        }

      }

      if(!this.visualizarAlumnos && !this.visualizarColaborador){
        this.mensajeService.Alerta(AlertaEnum.Warning, "No puedes enviar los correo");
      }
    }

    Formulario(accionid: number, entidad: Modelogoogle = new Modelogoogle()) {
      if(this.tieneCarpeta){
        let accion: string = ""
        switch (accionid) {
            case 1:
                accion = "Ver";
                break;
            case 2:
                accion = "Editar";
                break;
            case 3:
                accion = "Nuevo";
                break;
        }

        this.cargarContenedorFormulario({accionid: accionid, accion: accion, entidad: entidad});
      }else{
        let opciones = this.sistemaService.GetOpcionesConfirmar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Se creara la carpeta "Encuestas" en su direccion de Drive, donde estarán alojadas las encuestas que vaya creando desde el portal de Evaluación 360', opciones).then(res => {
          if (res == 1) {
            this.appService.Get("encuestagoogle/encuesta/generarcarpeta").then(res=>{
              if(res.status == RespuestaEstatusEnum.Success){
                this.tieneCarpeta = true;
                this.cargarContenedorFormulario({accionid: accionid, accion: "Nuevo", entidad: entidad});
              }
            })
          }
      })
      }
    }

    cargarContenedorFormulario(data: {accionid: number, accion: string, entidad: any}) {
    this.consulta = true;
    this.encuestadetalle.clear();
    const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(EncuestaDetalleComponent);
    var ref: ComponentRef<any> = this.encuestadetalle.createComponent(factory);
    ref.instance.accion = {accionid: data.accionid, accion: data.accion};
    ref.instance.entidad = data.entidad;
    ref.instance.output.subscribe((cambio: boolean) => {
      if(cambio){
       this.consultainicial();
      }
        this.consulta = false;
        ref.destroy();
    });
    }

    consultainicial(){
      this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
    }


    Buscar(){
      this.appService.Post("encuestagoogle/encuesta/buscarcolaborador", {"solopuestos":1}).then(res => {
        if (res.status == RespuestaEstatusEnum.Success) {
          this.listaColaborador = res.data;
        }
      })
    }

    BuscarAlumnos(){
      return new Promise((resolve) => {
        let data = {cicloid: this.enviarEncuesta.cicloid, nivelid: this.enviarEncuesta.nivelid}
        this.appService.Post("encuestagoogle/encuesta/tree/nivel", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.treeView.instance.option("items", res.data);
                return resolve(1);
            } else {
                return resolve(0);
            }
        })
    });
    }

    formato(item: any) {
      if (item.selected) {
          this.seleccionado.push(item.itemData);
          return;
      } else {
          (item.items as any[]).forEach((node) => {
              this.formato(node);
          })
      }
  }

    LoadAlumnos(){

    }

    Eliminar(entidad: any){
      console.log(entidad);
      if(entidad.encuestaestatusid == 1){
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro de querer eliminar el formulario?', this.sistemaService.GetOpcionesConfirmar()).then(res => {
          if(res == 1){
            this.appService.Delete("encuestagoogle/encuesta/" + entidad.formusuarioid).then(res => {
              if(res.status == RespuestaEstatusEnum.Success){
                this.consultainicial();
              }
            })
          }
        })
      }else{
        this.mensajeService.Alerta(AlertaEnum.Warning, "No se puede eliminar un formulario que ya ha sido enviado");
      }
    }
}
